import Axios from "axios";
import {
  SET_PRODUCTION_BOM_LIST,
  UNSET_PRODUCTION_BOM_LIST,
} from "@/store/mutation-types";

import { bomResource } from "@/store/api";

const state = {
  getProductionBomList: [],
};

const getters = {
  getProductionBomList(state) {
    return state.getProductionBomList;
  },
};

const mutations = {
  [SET_PRODUCTION_BOM_LIST](state, data) {
    state.getProductionBomList = data;
  },
  [UNSET_PRODUCTION_BOM_LIST](state) {
    state.getProductionBomList = [];
  },
};

const actions = {
  // ============================
  // GET BOM LIST
  // ============================
  getProductionBomList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(bomResource, { params })
        .then((response) => {
          commit(SET_PRODUCTION_BOM_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_BOM_LIST);
          reject(error);
        });
    });
  },

  // ============================
  // SAVE BOM
  // ============================
  saveProductionBom({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.post(bomResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // ============================
  // UPDATE BOM
  // ============================
  updateProductionBom({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${bomResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

getProductionBomById({ commit }, { id }) {
    commit("SET_LOADING", { color: "primary" });

    const url = `${bomResource}/${id}`;

    return new Promise((resolve, reject) => {
    Axios.get(url)
        .then((response) => {
        resolve(response);
        })
        .catch((error) => {
        reject(error);
        })
        .finally(() => {
        commit("UNSET_LOADING");
        });
    });
},

};

export default {
  state,
  getters,
  actions,
  mutations,
};
